import React, {useState} from "react";
import _ from "lodash";
import InfoItem from "../../common/InfoItem";
import PermissionsModal from "../../common/PermissionsModal";
import cvsFlavourMapper from "../../../utils/cvsInfo";
import commonStyles from "../../../styles/common.module.scss";
import styles from "./Info.module.scss";

export default ({ flavour }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const Logo = cvsFlavourMapper[flavour].logo;
    const infoItems = cvsFlavourMapper[flavour].infoItems;
    const permissionsModal = cvsFlavourMapper[flavour]?.permissionsModal;

    const closeDialog = () => {
        setIsModalOpen(false);
    };
    const openDialog = () => {
        setIsModalOpen(true);
    };
    return (
        <div className={styles["container"]}>
            <div className={styles["title"]}>
                <Logo className={styles["service-logo"]}/>
                <div className={commonStyles["title"]}>How to get the credentials</div>
            </div>
            {_.map(infoItems, (item, i) => <InfoItem key={i} {...item} openDialog={openDialog}/>)}
            {isModalOpen && <PermissionsModal closeDialog={closeDialog} {...permissionsModal}/>}
        </div>
    );
};

